import React, { useContext } from "react";
import Footer from "../components/Footer";
import { useTranslation } from "react-i18next";

import axios from "axios";
import { useState } from "react";
import Global from "../util/Global";
import { AlertContext } from "../util/Alerter";
import { LoaderComponent } from "../util/Loader";
const CONTACT_URL = Global.backend + "/index.php/user/contactUs";

const ContactUs = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const [email, setisEmail] = useState("");
  const [message, setisMessage] = useState("");
  const [subject, setisSubject] = useState("");
  const { showAlert } = useContext(AlertContext)


  function checkInputs() {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email) || message.length < 10 || subject.length < 4) {
      showAlert("error", t("user.verifycontactDetails"))
      return false
    }

    return true
  }

  function fetchContact() {
    if(!checkInputs()){
      return
    }
    setIsLoading(true);
    axios
      .post(CONTACT_URL, {
        email: email,
        message: message,
        subject: subject,
      })
      .then((response) => {
        console.log("message : " + response.data.message);
        if (response.data.message == "success") {
          showAlert("success", t('contact2.1'), t('contact1.1'))
        } else {
          showAlert("error", t('contact4.1'), t('contact3.1'))
        }
      }).catch((err) => {
        showAlert("error", t('contact4.1'), t('contact3.1'))
      })
      .finally(() => {
        setIsLoading(false);
      });
  }



  return (
    <div>


      <LoaderComponent isLoading={isLoading}>
        <div>
          <section className="ttm-row conatct-section ttm-bgcolor-grey clearfix">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="section-title title-style-center_text">
                    <div className="title-header">

                      <h2 className="title">
                        {t("Have A Questions Drop Us Line?.1")}
                      </h2>
                    </div>
                    <div className="title-desc">
                      <p>
                        {t(
                          "We take great pride in everything that we do, complete control over products allows us to ensure customers receive best service.1"
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-8">
                  <div className="ttm-bgcolor-white p-40 padding_top35 border-rad_5 margin_top15">
                    <div className="row">

                      <div className="col-md-12">
                        <span className="text-input">
                          <input
                            style={{
                              backgroundColor: "#EFF3FF",
                              border: "none",
                              marginBottom: 20,
                            }}
                            type="text"
                            placeholder={t("Your Email*.1")}
                            defaultValue={email}
                            onChange={(e) => setisEmail(e.target.value)}
                          />
                        </span>
                      </div>

                      <div className="col-md-12">
                        <span className="text-input">
                          <input
                            style={{
                              backgroundColor: "#EFF3FF",
                              border: "none",
                              marginBottom: 20,
                            }}
                            type="text"
                            placeholder={t("Subject*.1")}
                            defaultValue={subject}
                            onChange={(e) => setisSubject(e.target.value)}
                          />
                        </span>
                      </div>
                      <div className="col-lg-12">
                        <span className="text-input">
                          <textarea
                            style={{
                              backgroundColor: "#EFF3FF",
                              border: "none",
                              marginBottom: 25,
                            }}
                            rows="5"
                            placeholder={t("Message*.1")}
                            defaultValue={message}
                            onChange={(e) => setisMessage(e.target.value)}
                          ></textarea>
                        </span>
                      </div>
                      <div className="col-lg-12">
                        <button
                          className="submit ttm-btn ttm-btn-size-md ttm-btn-shape-rounded ttm-btn-style-fill  w-100 margin_top5 mycol"
                          onClick={() => fetchContact()}
                        >
                          {t("Send now!.1")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="ttm-bgcolor-white p-30 border-rad_5 margin_top15">
                    <div className="featured-icon-box icon-align-top-content margin_top0 margin_bottom25">
                      <div className="featured-icon">
                        <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-lg">
                          <i className="flaticon-email" style={{ color: "#3f2414" }}></i>
                        </div>
                      </div>
                      <div className="featured-content pt-2">
                        <div className="featured-title">
                          <h3 className="margin_bottom0 fs-20">
                            {t("Let’s Call or Email.1")}
                          </h3>
                        </div>
                        <div className="featured-desc">
                          contact@techoney.com
                        </div>
                      </div>
                    </div>

                    <div className="featured-icon-box icon-align-top-content margin_bottom10">
                      <div className="featured-icon">
                        <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-md"></div>
                      </div>
                      <div className="featured-content pt-2"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </LoaderComponent>
      <Footer />
    </div>
  );
};

export default ContactUs;
